import { FormGroup } from "@angular/forms";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import {
  obtenerSolicitudTipoId,
  SolicitudTiposEnum,
  SolicitudTiposIdEnum
} from 'src/app/core/models/request/afiliaciones/solicitud-tipos.enum';
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { DocumentosParentesco } from "./documentos-parentesco";

export class DocumentosConyuge extends DocumentosParentesco {
    constructor(personaControl: FormGroup,
                formulario: FormGroup,
                documentosService: ObligatoriedadDocumentosService
    ) {
            super(personaControl, formulario, documentosService);
    }

    async obtenerDocumentos() {
      if (this.datosAdicionales.solicitudId === SolicitudTiposEnum.CEC){
        const edad = this.calcularEdad(this.datosPersona.FechaNaciConyuge as Date);
        const filtro = {
          solicitudesTiposId: obtenerSolicitudTipoId(this.datosAdicionales.solicitudId),
          parentescosNombre: 'CONYUGE',
          edad,
          aplicaDiscapacidad: false,
          reglas: {
            reason: this.personaControl.get('reason')?.value
          }
        };
        this.documentosService.documentosConyuge = await this.documentosService.obtenerDocumentosFiltrados(filtro);
        this.documentosService.documentosConyugeSubject.next(this.documentosService.documentosConyuge);
      }else {
        const edad = this.calcularEdad(this.datosPersona.FechaNaciConyuge as Date);
        const filtro = {
          solicitudesTiposId: obtenerSolicitudTipoId(this.datosAdicionales.solicitudId),
          parentescosNombre: 'CONYUGE',
          edad,
          aplicaDiscapacidad: false,
          reglas: {
            parentesco: "CONYUGE",
            ocupacion_conyuge: InformationFormatting.returnNameOccupattion(this.datosPersona.OcupacionConyuge)
          }
        };
        this.documentosService.documentosConyuge = await this.documentosService.obtenerDocumentosFiltrados(filtro);
        this.documentosService.documentosConyugeSubject.next(this.documentosService.documentosConyuge);
      }
    }
}
